import React from "react";

import EquipmentMobileLoading from "./EquipmentMobileLoading";
import EquipmentMobileCard from "./EquipmentMobileCard";

const EquipmentMobileList = props => {
  const {
    equipmentList,
    equipmentLoader,
    pageLength,
    history,
    conditions,
    wildWords
  } = props;

  const list = () => {
    if (equipmentList.length === 0) {
      return;
    }
    return equipmentList
      .slice(0, pageLength)
      .map((elem, index) => (
        <EquipmentMobileCard
          wildWords={wildWords}
          history={history}
          elem={elem}
          key={`EquipmentList${index}`}
          conditions={conditions}
        />
      ));
  };

  return (
    <div>
      {equipmentLoader
        ? Array.apply(null, { length: pageLength }).map((e, i) => (
            <div key={i}>{EquipmentMobileLoading()}</div>
          ))
        : list()}
    </div>
  );
};

export default EquipmentMobileList;
